export default __webpack_public_path__ + "static/media/iconReportProblem.208800a8.svg";